export const defaultEventDomain = 'browser';
